import React from 'react'
import MenuItem from './MenuItem'

function Dropdown({name, children}) {
  let k = 0 // For generating unique key
  return(
    <div className='dropdown '>
      <div className='dropbtn'>
        {name}
        <div className="dropdown-content">
        {children.map((c) => {
          k++
          return(<MenuItem key={c+k}>{c}</MenuItem>)
        })}
        </div>
      </div>
    </div>
  )
}
export default Dropdown
